module.exports = __webpack_public_path__ + "imgs/webreact-f0b309ed6fa942d838b57d995ba17171.jpeg";